// extracted by mini-css-extract-plugin
export var cardContainer = "M_cy";
export var ourValues = "M_cx";
export var title = "M_bl";